import { api } from '@cwd/lib/main';

export interface PrePaidBalance {
    AccountBalance: number | null;
    SubscriptionBalance: number | null;
    FullBalance: number | null;
    CurrencyCode: string;
    CreditLimit: number;
}

export async function getPrePaidBalance(): Promise<PrePaidBalance> {
    return api.get('/Accounts/Current/PrePaidBalance');
}
